module.exports = __webpack_public_path__ + "img/status-report.49cdd23a.svg";